module.exports = __webpack_public_path__ + "static/media/tri.c07e0a95.svg";